import { getPermissionsForCoreUploadTypes } from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'
import { MATERIALS_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/materials')({
  staticData: {
    title: 'route.coreUploadData.materials',
    crumb: 'route.coreUploadData.materials',
    permissions: getPermissionsForCoreUploadTypes(MATERIALS_UPLOAD_TYPES),
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route, { atLeastOne: true })
  },
})
